import { Injectable } from '@angular/core';

@Injectable()
export class SearchService {

    public searchFilter(inputs, filterValues, filterFields) {
        return this._searchFilter(inputs, filterValues, filterFields, [], '', [], false, false, false, false, false);
    }

    public searchFilterExcludeNullFields(inputs, filterValues, filterFields) {
        return this._searchFilter(inputs, filterValues, filterFields, [], '', [], false, false, false, false, true);
    }

    public searchFilterForMenu(inputs, filterValues, filterFields, filterFunctionFields) {
        return this._searchFilter(inputs, filterValues, filterFields, filterFunctionFields, '', [], false, false, false, false, true);
    }

    public searchDateFilter(inputs, filterValues, filterFields) {
        return this._searchFilter(inputs, filterValues, filterFields, [], '', [], false, false, true, false, false);
    }

    public searchRangeDateFilter(inputs, filterValues, filterFields) {
        return this._searchFilter(inputs, filterValues, filterFields, [], '', [], true, true, true, false, false);
    }

    public searchRangeDateTimeFilter(inputs, filterValues, filterFields) {
        return this._searchFilter(inputs, filterValues, filterFields, [], '', [], true, true, false, true, false);
    }

    public searchRangeFilter(inputs, filterValues, filterFields) {
        return this._searchFilter(inputs, filterValues, filterFields, [], '', [], true, true, false, false, false);
    }

    private _searchFilter(inputs, filterValues, filterFields, filterFunctionFields, excludedValues, excludedFields, fullMatch, rangeFilter, isDate, isDateTime, excludeNullField) {
        if (filterValues === undefined || filterValues === null || filterValues === '') {
            return inputs;
        }

        var output = [];
        for (let input of inputs) {
            var isToFilter = true;
            for (var j = 0; j < excludedFields.length; j++) {
                if (input[excludedFields[i]] != null) {
                    if (excludedValues instanceof Array) {
                        for (var excludedValue in excludedValues) {
                            isToFilter = isToFilter && (this._normalize(input[excludedFields[j]], isDate, isDateTime).indexOf(this._normalize(excludedValue, isDate, isDateTime)) === -1);
                        };
                    } else {
                        isToFilter = isToFilter && (this._normalize(input[excludedFields[j]], isDate, isDateTime).indexOf(this._normalize(excludedValues, isDate, isDateTime)) === -1);
                    }
                }
            }

            if (isToFilter) {
                var currentValues = [];
                for (var i = 0; i < filterFields.length; i++) {
                    currentValues.push(input[filterFields[i]]);
                }
                for (var i = 0; i < filterFunctionFields.length; i++) {
                    currentValues.push(input[filterFunctionFields[i]]());
                }
                for (var i = 0; i < currentValues.length; i++) {
                    if (currentValues[i] != null) {
                        var currValue = this._normalize(currentValues[i], isDate, isDateTime);
                        if (filterValues instanceof Array) {
                            var isValid = false;
                            if (!rangeFilter) {
                                for (var filterValue in filterValues) {
                                    isValid = isValid || (fullMatch ? currValue === this._normalize(filterValue, isDate, isDateTime) : currValue.indexOf(this._normalize(filterValue, isDate, isDateTime)) !== -1);
                                }
                            } else {
                                // Assumo che in filterValues[0] ci sia lo start e in filterValues[1] ci sia lo stop
                                if (fullMatch) {
                                    var currVal = currValue;
                                } else {
                                    var currVal = currValue.substring(parseInt(filterValues[2]), parseInt(filterValues[3]));
                                }
                                if (filterValues[0] && filterValues[0] != '' && filterValues[1] && filterValues[1] != '') {
                                    isValid = currVal >= this._normalize(filterValues[0], isDate, isDateTime) && currVal <= this._normalize(filterValues[1], isDate, isDateTime);
                                } else if (filterValues[0] && filterValues[0] != '') {
                                    isValid = currVal >= this._normalize(filterValues[0], isDate, isDateTime);
                                } else if (filterValues[1] && filterValues[1] != '') {
                                    isValid = currVal <= this._normalize(filterValues[1], isDate, isDateTime);
                                } else {
                                    isValid = true;
                                }
                            }

                            if (isValid) {
                                output.push(input);
                                break;
                            }
                        } else {
                            if (fullMatch ? currValue === this._normalize(filterValue, isDate, isDateTime) : currValue.indexOf(this._normalize(filterValues, isDate, isDateTime)) !== -1) {
                                output.push(input);
                                break;
                            }
                        }
                    } else {
                        if (!excludeNullField) {
                            output.push(input);
                        }
                    }
                }
            } else {
                output.push(input);
            }
        }

        return output;
    }

    private _normalize(field: any, isDate: boolean, isDateTime: boolean) {
        if (isDate) {
            return this._convertDate(field).toLowerCase();
        } if (isDateTime) {
            return this._convertDateTime(field).toLowerCase();
        }

        return field.toString().toLowerCase();
    }

    private _convertDate(inputFormat) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        if (inputFormat instanceof Date) {
            const d = new Date(inputFormat);
            return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('/');
        } else {
            // Non posso convertire la stringa come data perchè prende il formato americano e inverte mese e giorno
            // e non c'è un Date.parse che accetta un formatter
            return inputFormat.substring(6, 10) + '/' + inputFormat.substring(3, 5) + '/' + inputFormat.substring(0, 2);
        }

    }

    private _convertDateTime(inputFormat) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        if (inputFormat instanceof Date) {
            const d = new Date(inputFormat);
            return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('/') + ' ' + [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
        } else {
            // Non posso convertire la stringa come data perchè prende il formato americano e inverte mese e giorno
            // e non c'è un Date.parse che accetta un formatter
            return inputFormat.substring(6, 10) + '/' + inputFormat.substring(3, 5) + '/' + inputFormat.substring(0, 2) + ' ' + inputFormat.substring(11, 19);
        }

    }
}
